// The sidebar menu, shared by App.vue (rendering) and the route guard in main.js (start page).

// Keeps the items that are not explicitly disabled, children included.
export function filterMenu(menu) {
    let filteredMenu = [];

    for (let i = 0; i < menu.length; i++) {
        const menuItem = menu[i];
        if (menuItem.enabled != false) {
            if (menuItem.children) {
                menuItem.children = filterMenu(menuItem.children);
            }
            filteredMenu.push(menuItem);
        }
    }

    return filteredMenu;
}

// First organization tab (route name) the user may open, or null when there is none.
// Resolved lazily (like src/router/index.js does): a static import of the organization
// module pulls in @/models before `models/user.js` has finished initialising, and
// `plugins/queryeditor/config.js` then reads `User` in its temporal dead zone
// ("Cannot access 'l' before initialization"), leaving every portal blank.
function getOrganizationStartPage(user) {
    const organizationModule = require('@/modules/organization');
    const tab = organizationModule.detail.tabs.find(tab => !tab.permissions || tab.permissions.some(permission => user.can(permission)));
    return tab ? tab.path : null;
}

// The sidebar items the user may see, in display order.
export function getSidebarMenu(user) {
    let tasksStartPage = 'tasks.routes';
    if (user.can('tasks.workflows.menu')) {
        tasksStartPage = 'tasks';
    } else if (user.can('tasks.jobs.menu')) {
        tasksStartPage = 'tasks.jobs';
    } else if (user.can('tasks.planning.menu')) {
        tasksStartPage = 'tasks.planning';
    }

    const organizationStartPage = getOrganizationStartPage(user);

    let dataStartPage = 'queries';
    if (!user.can('queries.menu')) {
        dataStartPage = 'exports';
    }

    return filterMenu([
        { icon: 'mdi-view-dashboard-outline', text: 'Dashboards', link: { name: 'dashboards' }, enabled: user.can('dashboard.menu') },
        {
            icon: 'mdi-clipboard-outline', model: false, text: 'Taken', link: { name: tasksStartPage }, enabled: (user.can('tasks.jobs.menu') || user.can('tasks.workflows.menu') || user.can('tasks.planning.menu') || user.can('routes.menu')),
            children: [
                { icon: 'mdi-form-select', text: 'Jobtypes', link: { name: 'jobTypes' }, enabled: user.can('jobtypes.menu') },
                { icon: 'mdi-sitemap', text: 'Workflows', tooltip: 'Workflow definities', link: { name: 'taskWorkflows' }, enabled: user.can('tasktypes.menu') },
            ]
        },
        { icon: 'mdi-folder-open-outline', text: 'Projecten', link: { name: 'projects' }, enabled: user.can('projects.menu') },
        {
            icon: 'mdi-file-sign', model: false, text: 'Diensten', link: { name: 'services' }, enabled: user.can('services.menu'),
            children: [
                { icon: 'mdi-file-tree', text: 'Types', link: { name: 'serviceTypes' }, enabled: user.can('servicetypes.menu') },
            ]
        },
        { icon: 'mdi-office-building-outline', text: 'Bedrijven', link: { name: 'companies' }, enabled: user.can('companies.menu') },
        { icon: 'mdi-cube-outline', text: 'Assets', link: { name: 'products' }, enabled: user.can('products.devices.menu') },
        { icon: 'mdi-tools', text: 'Gereedschap', link: { name: 'tools' }, enabled: user.can('products.tools.menu') },
        { icon: 'mdi-package-variant', text: 'Artikelen', link: { name: 'articles' }, enabled: user.can('products.articles.menu') },
        { icon: 'mdi-warehouse', text: 'Depots', link: { name: 'depots' }, enabled: user.can('depots.menu') },
        { icon: 'mdi-truck-outline', text: 'Voertuigen', link: { name: 'vehicles' }, enabled: user.can('vehicles.menu') },
        { icon: 'mdi-waveform', text: 'Meetwaardes', link: { name: 'measurementTypes' }, enabled: user.can('measurementtypes.menu') },
        { icon: 'mdi-image-multiple-outline', text: 'Opslag', link: { name: 'storage' }, enabled: user.can('storageobjects.menu') },
        { icon: 'mdi-view-list', text: 'Lijsten', link: { name: 'lists' }, enabled: user.can('lists.menu') },
        {
            icon: 'mdi-database-outline', model: false, text: 'Data', link: { name: dataStartPage }, enabled: (user.can('queries.menu') || user.can('exports.menu')),
            children: [
                { icon: 'mdi-database-search-outline', text: 'Queries', link: { name: 'queries' }, enabled: user.can('queries.menu') },
                { icon: 'mdi-database-arrow-right-outline', text: 'Exporteren', link: { name: 'exports' }, enabled: user.can('exports.menu') },
            ]
        },
        { icon: 'mdi-bell-alert-outline', text: 'Alarmen', link: { name: 'alarms' }, enabled: user.can('alarms.menu') },
        { heading: 'Instellingen', enabled: !!organizationStartPage },
        { icon: 'mdi-file-tree-outline', text: 'Organisatie', link: { name: organizationStartPage || 'organization' }, enabled: !!organizationStartPage }
    ]);
}

// The links of the sidebar in display order, each item followed by its children.
export function getSidebarLinks(user) {
    const links = [];

    const menu = getSidebarMenu(user);
    for (let i = 0; i < menu.length; i++) {
        const menuItem = menu[i];
        if (menuItem.link) {
            links.push(menuItem.link);
        }
        if (menuItem.children) {
            links.push(...menuItem.children.map(child => child.link));
        }
    }

    return links;
}
